import { GenericContainerCard, GenericWrapper } from './MobileUtilitiesTopMatch';
import { TopDecorColor } from '../../../specific_ppv_year_info_component/single_match_card_in_info_ppv_folder/GenericComponentCssMatchCard';
import { SpaceSideWrestlerCssComponent } from './GenericUtilitiesComponents/SpaceSideWrestlerCssComponent';
import SpaceInfoMatchComponent from './GenericUtilitiesComponents/SpaceInfoMatchComponent';
import MobileRenderTeamWhenTwoInSide from './GenericRenderWrestlerWithLogicNumber/TeamRender/MobileRenderTeamWhenTwoInSide';

function MobileTwoTagInSideTopMatchRender({ matchInfo }) {
    const $typeMatch = matchInfo.type_match.type;

    let teamLeft, teamRight, wrestlers1, wrestlers2, wrestlers3, wrestlers4;

    if($typeMatch === 'three_tag') {
        wrestlers1 = matchInfo.wrestlers.filter(wrestler => wrestler.team === 1);
        wrestlers2 = matchInfo.wrestlers.filter(wrestler => wrestler.team === 2);
        wrestlers3 = matchInfo.wrestlers.filter(wrestler => wrestler.team === 3);
        teamLeft = [wrestlers1, wrestlers2];
        teamRight = [wrestlers3];
    } else if($typeMatch === 'four_tag') {
        wrestlers1 = matchInfo.wrestlers.filter(wrestler => wrestler.team === 1);
        wrestlers2 = matchInfo.wrestlers.filter(wrestler => wrestler.team === 2);
        wrestlers3 = matchInfo.wrestlers.filter(wrestler => wrestler.team === 3);
        wrestlers4 = matchInfo.wrestlers.filter(wrestler => wrestler.team === 4);
        teamLeft = [wrestlers1, wrestlers2];
        teamRight = [wrestlers3, wrestlers4];
    }


    return (
        <GenericContainerCard className='mobile-two-in-side-top-match-render'>   
            <TopDecorColor className='top-decor-color' height='10px' borderTopLeftRadius='10px' borderTopRightRadius='10px' />
            <GenericWrapper className='wrapper-triple-top-match'>

                <SpaceSideWrestlerCssComponent className='space-side-team left'>
                    {teamLeft.map((team, index) => (
                        <MobileRenderTeamWhenTwoInSide
                            team={team}
                            side='left'
                            key={index}
                        />
                    ))}
                </SpaceSideWrestlerCssComponent>

                <SpaceInfoMatchComponent matchInfo={matchInfo} />

                <SpaceSideWrestlerCssComponent className='space-side-team right'>
                    {teamRight.map((team, index) => (
                        <MobileRenderTeamWhenTwoInSide
                            team={team}
                            side='right'
                            key={index}
                        />
                    ))}
                </SpaceSideWrestlerCssComponent>

            </GenericWrapper>
        </GenericContainerCard>
    )
}

export default MobileTwoTagInSideTopMatchRender;